<template>
	<div id="agaccount" class='gcardfr' v-loading='loading'>

		<el-row :gutter="20" class=''>
			<el-col :span='8'>
				<el-button size='small' type="primary" icon="el-icon-plus" @click='addTer'>{{ $t('app_add') }}</el-button>

				<!-- <el-button size='small' @click="batchDel" :disabled="sRows.length == 0" type='danger' plain>批量删除</el-button>     -->
			</el-col>
			<el-col :span='8'>
				<div class="glineflex">
					<label class="glinelb">{{ $t('terminal.device_sn') }}：</label>
					<el-input size='small' v-model='dvsn' @keyup.enter.native="indexget" placeholder="SN"></el-input>
				</div>
			</el-col>
			<el-col :span='8'>
				<div class="glineflex">
					<label class="glinelb">{{ $t('terminal.risk_name') }}：</label>
					<el-input size='small' v-model='srcKey' @keyup.enter.native="indexget" :placeholder="$t('app_name')"></el-input>
				</div>
			</el-col>

		</el-row>
		<!-- @selection-change="batchSelected" ref="multipleTable" -->
		<el-table class='gtbtop' tooltip-effect="dark" @row-click="rowClick" :data="tableData" style="width: 100%">
			<!-- <el-table-column
        type="selection"
        width="55">
      </el-table-column> -->
			<el-table-column prop="name" :label="$t('terminal.risk_name')" width="200">
			</el-table-column>
			<el-table-column prop="content" width="" :label="$t('terminal.risk_content')">
			</el-table-column>
			<el-table-column prop="createTime" :label="$t('app_createTime')" width="176">
			</el-table-column>
			<el-table-column prop="bindingNum" width="156" :label="$t('terminal.bound_device_num')">
			</el-table-column>
			<el-table-column :label="$t('app_operation')" width="140">
				<template slot-scope="scope">
					<el-button type='text' @click='editRow(scope.row)'>{{ $t('app_edit') }}</el-button>
					<label class='opbline'>|</label>
					<el-button @click='delRow(scope.row.id)' type='text' class='opdcolor'>{{ $t('app_delete') }}</el-button>
				</template>
			</el-table-column>
		</el-table>

		<Pages class='gpages' :cpage='page' :ctotal="total" :config='pconfig'></Pages>

		<el-dialog @close="closeDia" class='gstdia' :title="isEdit?  $t('app_edit') :  $t('app_add') " :visible.sync="showDia">
			<el-form :model="uform" :rules="rules" ref="ruleForm">
				<el-form-item :label="$t('terminal.risk_name')" :label-width="$formlbWidth" prop='name'>
					<el-input v-model="uform.name" autocomplete="off"></el-input>
				</el-form-item>
				<el-form-item :label="$t('terminal.risk_content')" :label-width="$formlbWidth" prop='content'>
					<el-input v-model="uform.content" autocomplete="off" type="textarea" :rows='5'></el-input>
				</el-form-item>
				<el-form-item :label="$t('terminal.app_distributor')" :label-width="$formlbWidth" prop='agentId'>
					<Merchant :config='sortMc'></Merchant>
				</el-form-item>
				<el-form-item :label-width="$formlbWidth">
					<el-button @click="closeDia">{{ $t("app_cancel") }}</el-button>
					<el-button type="primary" @click="rqsBefore">{{ $t("app_sure") }}</el-button>
				</el-form-item>
			</el-form>
			<!-- <div slot="footer" class="dialog-footer">
      </div> -->
		</el-dialog>

	</div>
</template>

<style>
	.eqbs-ball-green {
		width: 6px;
		height: 6px;
		display: inline-block;
		border-radius: 6px;
		overflow: hidden;
		background: rgba(82, 196, 26, 1);
	}

	.eqbs-ball-gray {
		width: 6px;
		height: 6px;
		display: inline-block;
		border-radius: 6px;
		overflow: hidden;
		background: rgba(191, 191, 191, 1);
	}
</style>

<script>
	import Pages from '@/components/Pages.vue'
	import Merchant from '@/components/Merchant.vue'

	export default {
		data() {
			return {
				dvsn: '',
				sortMc: {},
				editMc: {},
				isEdit: false,
				srcKey: '',
				pconfig: '',
				tableData: [],

				showDia: false,
				uform: {
					id: -1,
					name: '',
					content: '',
					agentId: '',
				},
				page: 1,
				total: 0,
				loading: false,
				sRows: [],
				rules: {
					name: [{
						required: true,
						message: this.$t("app_input"),
						trigger: 'blur'
					}],
					content: [{
						required: true,
						message: this.$t("app_input"),
						trigger: 'blur'
					}],
					agentId: [{
						required: true,
						message: this.$t("app_select"),
						trigger: 'blur'
					}],
				}
			}
		},
		components: {
			Pages,
			Merchant
		},
		methods: {
			setMc(vl) {
				this.sortMc = {
					size: 'small',
					value: vl,
					callback: (vl) => {
						this.uform.agentId = vl
					}
				}
			},
			toDetail(row) {
				this.$router.push({
					path: '/config/param/detail',
				})
				this.$setTmp('param', row)
			},
			rowClick(row, column) {
				if (column.label != this.$t('app_operation')) {
					this.toDetail(row)
				}
			},
			indexget() {
				this.page = 1
				this.getList()
			},
			setRole(row) {
				return this.$roleSt[row.roleName];
			},
			setStatus(row) {
				return this.$agAcSt[row.status]
			},
			rqsBefore() {
				this.$refs['ruleForm'].validate((valid) => {
					if (valid) {
						this.okDia()
					}
				})
			},
			batchDel() {
				this.$showMsgBox(this.$t('app_delete_question_2'), () => {
					var arr = []
					this.sRows.forEach(item => {
						arr.push(item.id)
					})
					this.delRqs(arr.toString())
				}, '')
			},
			editRow(row) {
				this.isEdit = true
				this.uform.id = row.id
				this.uform.name = row.name
				this.uform.content = row.content
				this.uform.agentId = row.agentId

				setTimeout(() => {
					this.setMc(this.uform.agentId)
				}, 200);

				this.showDia = true
			},
			delRqs(id) {
				this.loading = true
				this.$delConf(id, res => {
					this.loading = false
					if (res.status == 200) {
						this.getList()
					} else {
						this.$message.error(res.message)
					}
				}, () => {
					this.loading = false
				})
			},
			delRow(id) {
				this.$showMsgBox(this.$t('app_delete_question'), () => {
					this.delRqs(id)
				}, '')
			},
			addTer() {
				this.isEdit = false
				this.showDia = true
			},
			getList() {
				this.loading = true
				var key = this.srcKey ? this.srcKey : ''
				var sn = this.dvsn ? this.dvsn : ''
				this.$getConf(this.page, this.$gRow, key, sn, res => {
					this.loading = false
					if (res.status == 200) {
						this.total = res.total
						this.tableData = res.data
					} else {
						this.$message.error(res.message)
					}
				}, '')
			},
			batchSelected(val) {
				this.sRows = val
			},
			closeDia() {
				this.$refs['ruleForm'].resetFields()
				this.showDia = false
				this.uform.id = -1
				this.uform.name = ''
				this.uform.content = ''
				this.uform.agentId = ''
			},
			okDia() {
				var fm = this.uform
				this.loading = true
				if (this.isEdit) {
					//// eidt 
					this.$editConf(fm.id, fm.name, fm.content, fm.agentId, res => {
						this.loading = false
						if (res.status == 200) {
							this.closeDia()
							this.getList()
						} else {
							this.$message.error(res.message)
						}
					}, '')
				} else {
					/////  add
					this.$addConf(fm.name, fm.content, fm.agentId, res => {
						this.loading = false
						if (res.status == 200) {
							this.closeDia()
							this.getList()
						} else {
							this.$message.error(res.message)
						}
					}, '')
				}
			}
		},
		mounted() {
			var _this = this
			this.pconfig = {
				callback: page => {
					///
					_this.page = page
					_this.getList()
				}
			}

			this.setMc('')

			this.getList()
		}
	}
</script>
